import React from "react";
import { IconProps } from "../../../lib/types";

const BrightOutlook:React.FC<IconProps> = ({className}) =>{
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37.885"
      height="37.885"
      viewBox="0 0 37.885 37.885"
      className={className}
    >
      <path
        d="M8.894 11.41A1.777 1.777 0 0011.41 8.9L8.058 5.547a1.776 1.776 0 00-2.511 2.512zm10.048-3.123a1.776 1.776 0 001.776-1.776V1.776a1.776 1.776 0 00-3.552 0v4.735a1.776 1.776 0 001.776 1.776zM8.287 18.942a1.776 1.776 0 00-1.776-1.776H1.776a1.776 1.776 0 000 3.552h4.735a1.772 1.772 0 001.776-1.776zm19.446-7.015a1.768 1.768 0 001.256-.52l3.348-3.35a1.776 1.776 0 00-2.511-2.511L26.477 8.9a1.776 1.776 0 001.256 3.032zM18.942 29.6a1.776 1.776 0 00-1.776 1.776v4.736a1.776 1.776 0 003.552 0v-4.739a1.776 1.776 0 00-1.776-1.773zM8.894 26.475l-3.348 3.35a1.776 1.776 0 102.511 2.511l3.348-3.35a1.776 1.776 0 00-2.511-2.511zm27.215-9.308h-4.736a1.776 1.776 0 000 3.552h4.736a1.776 1.776 0 100-3.552zm-7.118 9.308a1.776 1.776 0 00-2.511 2.511l3.348 3.35a1.776 1.776 0 102.511-2.511zm-10.049-15.82a8.287 8.287 0 108.287 8.287 8.283 8.283 0 00-8.287-8.287z"
        className="a"
      ></path>
    </svg>
  );
}

export default BrightOutlook;
